import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';

export function useDetailsParams() {
  const { details } = useSearch({ from: '/_auth/esni' });
  const navigate = useNavigate({ from: '/esni' });

  const detailsValues = useMemo(() => details?.split(',') ?? [], [details]);

  const mediaId =
    detailsValues.find((value) => value.startsWith('media_'))?.replace('media_', '') ?? '';

  const viewingPolicyName =
    detailsValues.find((value) => value.startsWith('policy_'))?.replace('policy_', '') ?? '';

  const audienceHref = useMemo(() => {
    return detailsValues
      .filter((value) => value.startsWith('audience_'))
      .map((value) => value.replace('audience_', ''));
  }, [detailsValues]);

  /** Using "custom" allows the value to override the entire search param structure instead of appending to it */
  const setDetailsParam = useCallback(
    (key: 'media' | 'policy' | 'audience' | 'custom', value: string) => {
      const param = key === 'custom' ? value : `${key}_${value}`;
      const paramValue = key === 'custom' ? value : details ? `${details},${param}` : param;
      navigate({ replace: true, search: (params) => ({ ...params, details: paramValue }) });
    },
    [details, navigate],
  );

  const clearDetailsParam = useCallback(() => {
    navigate({ replace: true, search: (params) => ({ ...params, details: '' }) });
  }, [navigate]);

  return {
    audienceHref,
    clearDetailsParam,
    detailsValues,
    mediaId,
    setDetailsParam,
    viewingPolicyName,
  };
}
